import { render, staticRenderFns } from "./dashboardHeader.vue?vue&type=template&id=7168cb5e&scoped=true"
import script from "./dashboardHeader.vue?vue&type=script&lang=js"
export * from "./dashboardHeader.vue?vue&type=script&lang=js"
import style0 from "./dashboardHeader.vue?vue&type=style&index=0&id=7168cb5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7168cb5e",
  null
  
)

export default component.exports